<template>
  <div>
    <input
      type="text"
      :name="name"
      class="form-control form-control-sm"
      v-model="post"
      @input="send"
      @change="send"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  props: ["name", "validation", "content", 'disabled'],
  data() {
    return {
      post: this.content
    };
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    readonly() {
      if (this.name == 'srv_code') {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>